/**
 * Browser copy of resolve-cue-context (keep in sync with functions/integrations/noteslist/resolve-cue-context.js).
 */

const MARKER_TYPES = ['act', 'scene', 'song'];

function timelineKey(entry) {
    const pageIndex = Number(entry.pageIndex) || 0;
    const y = Number(entry.y) || 0;
    const x = Number(entry.x) || 0;
    return [pageIndex, y, x];
}

function compareTimeline(a, b) {
    const ka = timelineKey(a);
    const kb = timelineKey(b);
    for (let i = 0; i < 3; i += 1) {
        if (ka[i] !== kb[i]) {
            return ka[i] - kb[i];
        }
    }
    return 0;
}

function isBefore(a, b) {
    return compareTimeline(a, b) < 0;
}

function sortMarkers(markers) {
    return [...markers].sort(compareTimeline);
}

function findLastMarkerBefore(markers, cuePosition, type) {
    let last = null;
    for (const marker of markers) {
        if (marker.type === type && isBefore(marker, cuePosition)) {
            last = marker;
        }
    }
    return last;
}

function findNextSceneOrActAfter(markers, afterPosition, cuePosition) {
    for (const marker of markers) {
        if (marker.type === 'scene' || marker.type === 'act') {
            if (!isBefore(marker, afterPosition)) {
                if (isBefore(marker, cuePosition)) {
                    return marker;
                }
                if (compareTimeline(marker, cuePosition) === 0) {
                    return marker;
                }
            }
        }
    }
    return null;
}

function resolveCueContext(cue, markers) {
    const cuePosition = {
        pageIndex: cue.pageIndex != null ? cue.pageIndex : cue.pageNumber,
        x: cue.x || 0,
        y: cue.y || 0
    };

    const sorted = sortMarkers(
        (markers || []).filter(m => MARKER_TYPES.includes(m.type))
    );

    const actMarker = findLastMarkerBefore(sorted, cuePosition, 'act');
    const sceneMarker = findLastMarkerBefore(sorted, cuePosition, 'scene');
    const songMarker = findLastMarkerBefore(sorted, cuePosition, 'song');

    let songLabel = songMarker ? songMarker.label : null;
    if (songMarker) {
        const songEnd = findNextSceneOrActAfter(sorted, songMarker, cuePosition);
        if (songEnd && isBefore(songEnd, cuePosition)) {
            songLabel = null;
        }
    }

    return {
        actLabel: actMarker ? actMarker.label : null,
        sceneLabel: sceneMarker ? sceneMarker.label : null,
        songLabel,
        pageIndex: cuePosition.pageIndex
    };
}

export default resolveCueContext;


// WEBPACK FOOTER //
// ./src/lib/resolve-cue-context.js